<template>
  <el-select :value="value" placeholder="请选择身份" v-bind="$attrs" v-on="$listeners">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'IdentitySelect',
  props: {
    value: {
      required: true,
    },
    size: {
      type: String,
      default() {
        return 'medium'
      },
    },
    params: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      options: [],
    }
  },
  watch: {
    params: {
      handler() {
        this._loadData()
      },
      immediate: true,
    },
  },
  methods: {
    _loadData() {
      if (this.params == null) {
        this.options = []
      } else {
        this.options = [
          { label: '执业医师', value: '执业医师' },
          // { label: '住院医生', value: '住院医生' },
          // { label: '其他医务工作者', value: '其他医务工作者' },
          { label: '医学生', value: '医学生' },
          { label: '其他', value: '其他' },
        ]
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
